import { User } from "./user";

export class ErrorMessage {
    public id?: string;
    public message?: string;
    public tonnageId?: string | null;
    public tollId?: string | null;
    public creationUser?: User;
    public creationDate: Date;

    constructor(errorMessage?: ErrorMessage) {
        this.id = errorMessage?.id;
        this.message = errorMessage?.message;
        this.tonnageId = errorMessage?.tonnageId || null;
        this.tollId = errorMessage?.tollId || null;
        this.creationUser = errorMessage?.creationUser;
        this.creationDate = errorMessage?.creationDate || new Date();
    }
}
